/* eslint-disable react/no-unused-state */
import React from "react";
import moment from "moment";
import get from "lodash/get";
import { connect } from "react-redux";

import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { saveExcelBlob } from "../../../../shared/methods/sharedMethods";
import { newReconDownloadExcelAPI } from "../../../../services/APIutils";
import { BarLoader, ExportButton, Button } from "../../../../shared/widgets";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { templateStrings, MessageType, NEW_BASE_URL } from "../../../../Constant";
import { setNotificationMessage } from "../../../../redux/actions/notificationAction";
import UploadExcelModal from "../../../../shared/components/fileupload/UploadExcelModal";
import { getSettlementDistanceStatusService } from "../../../../services/distanceReportService";
import { distanceReportDetailsAction } from "../../../../redux/action-creators/distanceReportActionCreator";

import "./distanceReportView.css";

class DistanceReportView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
      settlementDistanceProcessState: {
        isProcessing: true,
        message: "",
      },
    };
    this.getList = this.getList.bind(this);
    this.openUploadXlsxModal = this.openUploadXlsxModal.bind(this, null);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.getList();
    this.getSettlementDistanceStatus();
  }

  componentDidUpdate(prevProps) {
    const {
      cityFilter, operatorFilter, dateFilter, dataSync,
    } = this.props;
    if (
      (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.dateFilter !== dateFilter)
      || (prevProps && prevProps.dataSync !== dataSync && dataSync === true)
    ) {
      this.getList();
    }
  }

  // handleDatesChange = (dates) => {
  //   if (dates.startDate && dates.endDate) {
  //     let fromDate = parseFloat(new Date(dates.startDate).getTime());
  //     let toDate = parseFloat(new Date(dates.endDate).getTime());
  //     this.props && this.props.selectDateFilter({ fromDate, toDate });
  //   }
  // };

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  }

  getSettlementDistanceStatus = () => {
    getSettlementDistanceStatusService().then((res) => {
      this.setState({
        settlementDistanceProcessState: res,
      });
    });
  };

  getList() {
    const { distanceReportDetailsFetched, operatorFilter, location } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    if (
      get(this, "props.location.state._fromDate", null)
      && get(this, "props.location.state._toDate", null)
    ) {
      distanceReportDetailsFetched({
        pageNo,
        pageSize: rowsPerPage,
        dateFilter: {
          fromDate: moment(new Date(get(this, "props.dateFilter.fromDate", null) || "")).format("YYYY-MM-DD").toString(),
          toDate: moment(new Date(get(this, "props.dateFilter.toDate", null) || "")).format("YYYY-MM-DD").toString(),
        },
        cityId: get(this, "props.location.state.cityId", null),
        operatorFilter,
        agencyId: location?.state?.agencyId || "",
        sortBy,
      }, "header");
    } else {
      const { history } = this.props;
      history?.push("/report/distance");
    }
  }

  downloadSampleExcel = async () => {
    const url = `${NEW_BASE_URL}/v1/reconReports/sampleSettlementDistanceUploadSheet`;
    await newReconDownloadExcelAPI(url, {}).then((res) => {
      let fileName = res.headers["content-disposition"]?.split("Filename=")[1];
      fileName = fileName?.replaceAll("\"", "");
      saveExcelBlob({ blob: res.data, fileName });
    }).catch((err) => {
      const { initiateNotification } = this.props;
      initiateNotification({ type: MessageType.ERROR, message: err.message });
    });
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  openUploadXlsxModal() {
    this.setState({
      showUploadXlsxModal: true,
    });
  }

  displayUploadXlsxModalModal() {
    const { showUploadXlsxModal, settlementDistanceProcessState } = this.state;
    return (
      <UploadExcelModal
        showModal={showUploadXlsxModal}
        messageCallBack={(type) => {
          if (type === MessageType.SUCCESS) {
            this.getSettlementDistanceStatus();
          }
          if (type === MessageType.SUCCESS || !(type && type === MessageType.ERROR)) {
            this.setState({
              showUploadXlsxModal: false,
            });
          }
        }}
        isUploadDisabled={settlementDistanceProcessState.isProcessing}
        uploadType="distance"
        addOnFilter={{
          cityId: get(this, "props.location.state.cityId", null) || "",
          agencyId: get(this, "props.location.state.agencyId", null) || "",
          fromDate: moment(new Date(get(this, "props.dateFilter.fromDate", null) || "")).format("YYYY-MM-DD").toString(),
          toDate: moment(new Date(get(this, "props.dateFilter.toDate", null) || "")).format("YYYY-MM-DD").toString(),
        }}
      />
    );
  }

  render() {
    const {
      headerLoader, content, totalItems, operatorFilter, location, distanceReportDataSync,
      refreshUpliftStatus,
    } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected, settlementDistanceProcessState, showUploadXlsxModal,
    } = this.state;

    const exportExcel = {
      endpoint: "reconReports/exportSettlementDistanceDetails",
      query: {
        platform: "web",
        timezoneOffset: -330,
        cityId: get(this, "props.location.state.cityId", null) || "",
        operatorIdArr: operatorFilter || [],
        fromDate: get(this, "props.location.state._fromDate", null) || "",
        toDate: get(this, "props.location.state._toDate", null) || "",
        agencyId: location?.state?.agencyId || "",
      },
    };
    const templateString = templateStrings.distanceReport;
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header heading="Distance Report" showBackArrow hideS>
            {distanceReportDataSync && "Upload is in process..."}
            {/* <Hidden only={["sm", "xs"]}> */}
            <div className="btn-wrapper">
              {settlementDistanceProcessState.isProcessing
                && <span className="in-process-text">{settlementDistanceProcessState.message}</span>}
              {/* <a className="xlsx-wrapper" href="/assets/Sample.xlsx">Sample File</a> */}
              <div role="link" className="xlsx-wrapper cursor-pointer" onClick={this.downloadSampleExcel} onKeyDown={() => { /* onKeyDown */ }} tabIndex="0">Sample File</div>
              <div>
                <div className="btn-wrapper">
                  <ExportButton
                    query={exportExcel.query}
                    endpoint={exportExcel.endpoint}
                    pageName="Distances"
                    isDisable={refreshUpliftStatus === "Data Sync In Process"}
                  />
                </div>
                <Button
                  disable={distanceReportDataSync || settlementDistanceProcessState.isProcessing}
                  onClick={this.openUploadXlsxModal}
                  buttonText="Upload"
                />
              </div>
            </div>
            {/* <Hidden only={["sm", "xs"]}>
                <div className="pull-right z-index-10">
                <ButtonToolbar>
                  <RangePicker
                    startDate={moment(new Date(this.props.dateFilter.fromDate))}
                    endDate={moment(new Date(this.props.dateFilter.toDate))}
                    monthsToDisplay={1}
                    onDatesChange={this.handleDatesChange}
                  />
                </ButtonToolbar>
              </div>
            </Hidden> */}
          </PageWrapper.Header>
          <PageWrapper.Body>
            <BarLoader scope="header" />
            <TableWrapper
              content={!headerLoader && content}
              pageNo={pageNo}
              selected={selected}
              uniqueKey="uniqKey"
              rowsPerPage={rowsPerPage}
              count={totalItems}
              handleChange={this.handleChange}
              templateString={templateString}
              selectionAllowed={false}
              onSortToggle={this.onSortToggle}
              sortBy={sortBy}
              tableContainerClassName="settlement-distance"
            />
            {showUploadXlsxModal && this.displayUploadXlsxModalModal()}
          </PageWrapper.Body>
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      state?.Report?.distanceReportDetails?.items || [],
    totalItems:
      state?.Report?.distanceReportDetails?.totalItems || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    distanceReportDataSync: (state
      && state.Report
      && state.Report.distanceReportDetails
      && state.Report.distanceReportDetails.dataSyncStatus
    ),
  };
}

const mapDispatchToProps = (dispatch) => ({
  distanceReportDetailsFetched: (params, loaderScope) => {
    dispatch(distanceReportDetailsAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DistanceReportView);
